const DELIVERYMAN_MANAGER_SUBPAGE = {
  header: {
    title: 'Pessoas Entregadoras',
  },
  subheader: {
    title: 'Gerencie as pessoas entregadoras.',
    subtitle:
      'Use a lista abaixo para gerenciar as pessoas entregadoras da sua loja',
    buttonLabel: 'Adicionar entregador',
  },
  search: {
    inputLabel: 'Filtre um entregador por nome',
    buttonLabel: 'Filtrar',
    multiselectPlaceholder: 'Status no App',
  },
  table: {
    header: {
      courier: 'Entregador',
      phone: 'Telefone',
      action: 'Ação',
    },
    row: {
      action: 'Excluir',
    },
    buttonMoreLabel: 'mostrar mais',
    on: 'Online',
    off: 'Offline',
  },
}

export default DELIVERYMAN_MANAGER_SUBPAGE
